import React, { useEffect, useState } from "react";

import PageLayout from "../../components/PageLayout";
import { canAccessSettlementInsights, getLoginDetails } from "../../utils/storage";
import InsightsHeaderIcon from "../../icons/newicons/insights.svg";
import { InsightsSubNav } from "./InsightsSubNav";
import LotHedgeSettlementV1 from "./LotHedgeSettlementV1";
import LotHedgeSettlementV2 from "./LotHedgeSettlementV2";
import LotHedgeSettlementV3 from "./LotHedgeSettlementV3";

import "./insights.css";
import "./lot-hedge-settlement.css";

const VERSIONS = [
  {
    id: "v1",
    label: "V1",
    title: "Lot Hedge Settlement",
    subtitle:
      "Carts share a ceramicLot. Lots fill multiple active hedges by FIFO. Partner settlements list ounces per lot.",
  },
  {
    id: "v2",
    label: "V2",
    title: "Lot Hedge Settlement",
    subtitle: "Live ceramic lots from invoices — lot name, Pt/Pd/Rh ounces, and ceramic amount.",
    live: true,
  },
  {
    id: "v3",
    label: "V3",
    title: "Lot Hedge Settlement",
    subtitle:
      "All our ceramic lots, enriched from oemlots when Number-Lot number matches.",
    live: true,
  },
];

const LotHedgeSettlement = () => {
  const loginDetails = getLoginDetails();
  const canView = canAccessSettlementInsights(loginDetails);
  const [version, setVersion] = useState("v2");
  const [showCreateSettlement, setShowCreateSettlement] = useState(false);

  useEffect(() => {
    if (!canView) window.location.href = "/";
  }, [canView]);

  useEffect(() => {
    if (version !== "v2") setShowCreateSettlement(false);
  }, [version]);

  if (!canView) return null;

  const active = VERSIONS.find((v) => v.id === version) || VERSIONS[1];

  return (
    <PageLayout icon={InsightsHeaderIcon} heading="Insights" searchPlaceholder="" hideSearchBar>
      <InsightsSubNav />

      <div className="lot-hedge-version-bar">
        <div className="lot-hedge-version-bar-copy">
          <h2 className="lot-hedge-version-bar-title">
            {active.title}{" "}
            <span
              className={`lot-hedge-version-pill${
                active.live ? " lot-hedge-version-pill--live" : ""
              }`}
            >
              {active.label}
            </span>
          </h2>
          <p className="lot-hedge-version-bar-subtitle">{active.subtitle}</p>
        </div>
        <div className="lot-hedge-version-bar-actions">
          <div className="lot-hedge-version-toggle" role="tablist" aria-label="Lot settlement version">
            {VERSIONS.map((v) => (
              <button
                key={v.id}
                type="button"
                role="tab"
                aria-selected={version === v.id}
                className={`lot-hedge-version-btn${version === v.id ? " is-active" : ""}`}
                onClick={() => setVersion(v.id)}
              >
                {v.label}
              </button>
            ))}
          </div>
          {version === "v2" && (
            <button
              type="button"
              className="lot-hedge-primary-btn"
              onClick={() => setShowCreateSettlement(true)}
            >
              Create Settlement
            </button>
          )}
        </div>
      </div>

      {version === "v1" ? (
        <LotHedgeSettlementV1 />
      ) : version === "v2" ? (
        <LotHedgeSettlementV2
          showCreateSettlement={showCreateSettlement}
          onCloseCreateSettlement={() => setShowCreateSettlement(false)}
        />
      ) : (
        <LotHedgeSettlementV3 />
      )}
    </PageLayout>
  );
};

export default LotHedgeSettlement;
